import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

export interface PageConfig {
  title: string;
  path: string[] | string;
  icon: string;
  isActive: boolean;
  order: number;
}
@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.scss'],
})
export class HeaderNavComponent implements OnInit {
  private homePath: PageConfig = {
    title: 'Home',
    order: 0,
    path: ['home'],
    icon: 'home',
    isActive: false,
  };

  @Input() pagesConfig: PageConfig[] = [];

  formattedPaths: PageConfig[] = [];

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    this.formattedPaths = this.pagesConfig.concat(this.homePath).sort((a, b) => a.order - b.order);
  }

  navigate(path: string[] | string) {
    if (typeof path === 'string') {
      this.router.navigateByUrl(path);
    } else {
      this.router.navigate(path);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/layout/header-nav/header-nav.component.ts